<template>
  <div class="scroller">
    <slot/>
    <div
      class="footer"
      v-if="showButtons">
      <div
        class="buttons"
        :class="[hideToTop? 'buttons-2': 'buttons-3']">
        <div
          @click="scrollDown()"
          class="button down">
          <i class="n-i n-i-arrow-down-a"/>
        </div>
        <div
          v-if="!hideToTop"
          class="button top"
          @click="scrollToTop()">
          <div class="icons-container">
            <i class="n-i n-i-arrow-up-a"/>
            <i class="n-i n-i-arrow-up-a"/>
          </div>
          <span class="button-text">{{ toTopTitle }}</span>
        </div>
        <div
          class="button up"
          @click="scrollUp()">
          <i class="n-i n-i-arrow-up-a"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  name: 'Scroller',
  props: {
    hideToTop: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    toTopTitle() {
      return this.$store.getters.getTranslation('main.to_top');
    },
  },
  data() {
    return {
      totalHeight: 0,
      el: null,
      showButtons: true,
      updateTimeout: null,
    };
  },
  mounted() {
    this.updateTimeout = setTimeout(() => {
      this.el = this.$slots.default[0].elm;
      this.updateSize();
    }, 0);

    this.scrollTop = 0;
  },
  destroyed() {
    clearTimeout(this.updateTimeout);
  },
  updated() {
    this.$nextTick(() => {
      this.updateSize();
    });
  },
  methods: {
    scrollDown() {
      $(this.el).stop().animate({ scrollTop: this.el.scrollTop + this.totalHeight * 0.8 }, 'smooth');
    },
    scrollToTop() {
      $(this.el).stop().animate({ scrollTop: 0 }, 'smooth');
    },
    scrollUp() {
      $(this.el).stop().animate({ scrollTop: this.el.scrollTop - this.totalHeight * 0.8 }, 'smooth');
    },
    updateSize() {
      this.totalHeight = this.el ? this.el.clientHeight : 0;
      this.showButtons = this.el && (this.el.scrollHeight > this.totalHeight);
    },
  },
};
</script>


<style lang="scss" scoped>
.scroller {
  position: relative;
  padding-bottom: 50px;
}

.footer {
  width: 100%;

  .buttons {
    height: 50px;

    &-3 {
      .button {
        width: 33.33%;
      }
    }

    &-2 {
      .button {
        width: 50%;
      }
    }
  }

  .top {
    background: #0066ae;

    .icons-container {
      margin-top: 5px;
    }

    .button-text {
      display: block;
      line-height: 25px;
    }

    i {
      display: block;
      line-height: 5px;
    }
  }

  .down,
  .up {
    background: #213143;
  }

  .button {
    float: left;
    width: 33.33%;
    height: 100%;
    text-align: center;
    line-height: 50px;
  }
}
</style>
